<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import A from "../lib/Router/A.svelte";
    import app from '../stores/app';
    import {sort, copyObjectData} from "../lib/lib";
    import R, {LOADER} from "../lib/requests";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import DepartmentEdit from "./DepartmentEdit.svelte";
    import ColoredNameControl from "../components/controls/ColoredNameControl.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";


    let departments = null;
    let selectedId = 0;

    const pageHeaderControls = [
        {id: 'create', name: 'CREATE DEPARTMENT', link: '/app/department/create', class: 'hidden-xs'},
        {
            id: 'create',
            name: '',
            icon: 'plus-circle',
            link: '/app/department/create',
            class: 'hidden-xl hidden-lg hidden-md hidden-sm'
        },
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'NAME', sortable: true, sort_way: 'ASC'},
        {key: 'account', title: 'ACCOUNT', sortable: true, class: 'hidden-sm hidden-xs'},
        {key: 'total_hotels', title: 'HOTELS', sortable: true, class: 'hidden-sm hidden-xs'},
        {key: 'total_users', title: 'USERS', sortable: true, class: 'hidden-sm hidden-xs'},
        {key: 'link_code', title: 'LINK', sortable: true, class: 'hidden-sm hidden-xs'},
        {key: '', title: ''},
    ];

    const load = () => {
        const onSuccess = result => {
            departments = result;
        }

        const onFailure = err => {
        };

        R.handle(R.department.index, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const onColumnSort = ({detail: column}) => {
        departments = sort(departments, column.key, column.sort_way === 'ASC');
    }

    const updateRecord = (department) => {
        department.total_users = department.users.length;
        let item = departments.find(x => x.id === department.id);
        if (!item) {
            departments = [department, ...departments];
        } else {
            copyObjectData(department, item, true);
            item.account = department.account;
            departments = departments;
        }
    }

    const onEdit = (department) => {
        selectedId = department.id;
        router.go(`/app/department/${selectedId}`)();
    }

    const onDelete = (department) => {
        Alert.delete("Delete department", `This will permanently delete department "${department.name}".\nAre you sure?`, () => deleteDepartment(department.id));
    }

    const deleteDepartment = (id) => {
        const onSuccess = result => {
            departments = departments.filter(x => x.id !== result);
            Notifier.showMessage("Department deleted");
        }

        const onFailure = err => {
            if (err.code === 'object_related') {
                let message = [];

                Object.keys(err.params).map(key => {
                    if (err.params[key] > 0) {
                        message.push(`${err.params[key]} ${key}`);
                    }
                });

                Alert.warning("Delete department", `Department is associated with ${message.join(", ")}.\nYou can not delete this department.`);
            }
        };

        R.handle(R.department.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>

<Route exact>
    <PageHeader title="Departments" controls={ pageHeaderControls } on:reload={ load }/>

    {#if departments}
        <div class="panel">
            <div class="panel-body">
                {#if departments.length}
                    <table class="table table-list table-list-border">
                        <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                        <tbody>
                        {#each departments as department}
                            <tr class="row-hover" class:row-selected="{ selectedId === department.id }">
                                <td>
                                    <ColoredNameControl name="{ department.name }" color="{ department.color }" isLink
                                                        isActive="{ department.is_active }"
                                                        on:click="{ () => onEdit(department) }"/>
                                </td>
                                <td class="hidden-sm hidden-xs">
                                    {#if department.account}
                                        <A href="/app/account/{ department.account_id }" class="text-gray is-link">
                                            <span class:not-active={ department.account.is_active < 1 }>
                                                { department.account.name }
                                            </span>
                                        </A>
                                    {/if}
                                </td>
                                <td class="users-column text-gray hidden-sm hidden-xs">
                                    {#if department.total_hotels > 0}
                                        { department.total_hotels }
                                    {/if}
                                </td>
                                <td class="users-column text-gray hidden-sm hidden-xs">
                                    {#if department.total_users > 0}
                                        { department.total_users }
                                    {/if}
                                </td>
                                <td class="users-column hidden-sm hidden-xs">
                                    {#if department.link_code}
                                        <a href={$app.department_reservation_url}/{department.link_code} target="_blank">
                                            <AppIcon icon="link" size="16"/>
                                        </a>
                                    {/if}
                                </td>
                                <td class="button-column pointer" title="delete department"
                                    on:click="{ () => onDelete(department) }">
                                    <AppIcon icon="trash" size="16"/>
                                </td>
                            </tr>
                        {/each}
                        </tbody>
                    </table>
                {:else}
                    <div class="panel-pad">
                        <p>
                            There are no departments
                        </p>
                        <A href="/app/department/create" class="btn btn-primary">CREATE A DEPARTMENT</A>
                    </div>
                {/if}
            </div>
        </div>
    {/if}
</Route>
<Route match="*" let:router>
    <DepartmentEdit updateCallback="{ updateRecord }" departmentId="{ router.star }"/>
</Route>

<style>
    .users-column {
        width: 90px;
        text-align: center;
    }
</style>